import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  HomePage,
  LPSharesPage,
  NotFound,
} from "@/pages";
import { LandingLayout, ContactSalesModal } from "@/components";
import { AppProvider } from "./hooks";
import { PrivacyPolicy, DataUsePolicy, TermsOfService } from "./pages/legal";
// import Intercom from "@intercom/messenger-js-sdk";

export default () => {
  // Hide Intercom for now because of site loading issues
  // Uncomment the following lines to enable Intercom
  // Intercom({
  //   app_id: "itnqa49d",
  // });

  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route path="/legal/privacy-policy"
            element={
              <LandingLayout>
                <PrivacyPolicy />
              </LandingLayout>
            }
          />
          <Route
            path="/legal/data-use-policy"
            element={
              <LandingLayout>
                <DataUsePolicy />
              </LandingLayout>
            }
          />
          <Route
            path="/legal/terms-of-service"
            element={
              <LandingLayout>
                <TermsOfService />
              </LandingLayout>
            }
          />

          <Route path="/"
            element={
              <LandingLayout>
                <HomePage />
              </LandingLayout>
            }
          />

          <Route path="/lpshares"
            element={
              <LandingLayout>
                <LPSharesPage />
              </LandingLayout>
            }
          />

          <Route path="/404" element={<NotFound />} />

          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>

        <ContactSalesModal />
      </AppProvider>
    </BrowserRouter>
  );
};
